import React, { useState } from 'react';

const AdminHeader = ({ member, onBurgerClick, onLogout }) => {
  const [profileOpen, setProfileOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);

  return (
    <div style={styles.header}>
      {/* Left side - Burger + Title */}
      <div style={styles.left}>
        <button style={styles.burgerBtn} onClick={onBurgerClick}>
          <div style={styles.burgerLine} />
          <div style={styles.burgerLine} />
          <div style={styles.burgerLine} />
        </button>
        <div style={styles.titleBox}>
          <span style={styles.title}>DULIMBAY</span>
          <span style={styles.subtitle}>Admin Dashboard</span>
        </div>
      </div>

      {/* Right side - Notif + Profile */}
      <div style={styles.right}>

        {/* Notification Bell */}
        <div style={styles.iconWrapper}>
          <button style={styles.iconBtn} onClick={() => {
            setNotifOpen(!notifOpen);
            setProfileOpen(false);
          }}>
            🔔
            <span style={styles.badge}>3</span>
          </button>
          {notifOpen && (
            <div style={styles.dropdown}>
              <p style={styles.dropdownTitle}>Notifications</p>
              <div style={styles.notifItem}>
                <p style={styles.notifText}>🟡 New signup request from Juan Dela Cruz</p>
                <span style={styles.notifTime}>2 mins ago</span>
              </div>
              <div style={styles.notifItem}>
                <p style={styles.notifText}>🔴 Costume not returned by Maria Santos</p>
                <span style={styles.notifTime}>1 hour ago</span>
              </div>
              <div style={styles.notifItem}>
                <p style={styles.notifText}>🟡 New signup request from Pedro Reyes</p>
                <span style={styles.notifTime}>3 hours ago</span>
              </div>
            </div>
          )}
        </div>

        {/* Profile */}
        <div style={styles.iconWrapper}>
          <button style={styles.profileBtn} onClick={() => {
            setProfileOpen(!profileOpen);
            setNotifOpen(false);
          }}>
            <div style={styles.avatar}>
              {member?.first_name?.charAt(0)}{member?.last_name?.charAt(0)}
            </div>
            <span style={styles.memberName}>
              {member?.first_name} {member?.last_name}
            </span>
          </button>
          {profileOpen && (
            <div style={styles.dropdown}>
              <p style={styles.dropdownTitle}>My Account</p>
              <div style={styles.profileInfo}>
                <div style={styles.avatarLarge}>
                  {member?.first_name?.charAt(0)}{member?.last_name?.charAt(0)}
                </div>
                <p style={styles.profileName}>
                  {member?.first_name} {member?.last_name}
                </p>
                <p style={styles.profileRole}>Admin</p>
                <p style={styles.profileId}>{member?.school_id}</p>
              </div>
              <button style={styles.logoutBtn} onClick={onLogout}>
                🚪 Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '65px',
    background: 'linear-gradient(135deg, #0f3460, #16213e)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 20px',
    zIndex: 999,
    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  burgerBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '5px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  burgerLine: {
    width: '24px',
    height: '2px',
    background: 'white',
    borderRadius: '2px',
  },
  titleBox: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '18px',
    letterSpacing: '2px',
  },
  subtitle: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: '11px',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  iconWrapper: {
    position: 'relative',
  },
  iconBtn: {
    background: 'rgba(255,255,255,0.1)',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    cursor: 'pointer',
    fontSize: '18px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  badge: {
    position: 'absolute',
    top: '-2px',
    right: '-2px',
    background: '#e74c3c',
    color: 'white',
    borderRadius: '50%',
    width: '18px',
    height: '18px',
    fontSize: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
  },
  profileBtn: {
    background: 'rgba(255,255,255,0.1)',
    border: 'none',
    borderRadius: '20px',
    padding: '5px 12px 5px 5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  avatar: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: '#e74c3c',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '13px',
  },
  avatarLarge: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    background: '#e74c3c',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '22px',
    margin: '0 auto 10px',
  },
  memberName: {
    color: 'white',
    fontSize: '13px',
    fontWeight: '600',
  },
  dropdown: {
    position: 'absolute',
    top: '50px',
    right: '0',
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
    minWidth: '260px',
    zIndex: 1000,
    overflow: 'hidden',
  },
  dropdownTitle: {
    padding: '15px 20px 10px',
    fontWeight: 'bold',
    color: '#333',
    borderBottom: '1px solid #eee',
    margin: 0,
    fontSize: '14px',
  },
  notifItem: {
    padding: '12px 20px',
    borderBottom: '1px solid #f5f5f5',
    cursor: 'pointer',
  },
  notifText: {
    margin: '0 0 4px 0',
    fontSize: '13px',
    color: '#333',
  },
  notifTime: {
    fontSize: '11px',
    color: '#aaa',
  },
  profileInfo: {
    padding: '20px',
    textAlign: 'center',
    borderBottom: '1px solid #eee',
  },
  profileName: {
    fontWeight: 'bold',
    color: '#333',
    margin: '0 0 4px 0',
    fontSize: '15px',
  },
  profileRole: {
    color: '#0f3460',
    fontWeight: '600',
    fontSize: '13px',
    margin: '0 0 4px 0',
  },
  profileId: {
    color: '#aaa',
    fontSize: '12px',
    margin: 0,
  },
  logoutBtn: {
    width: '100%',
    padding: '14px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#e74c3c',
    fontWeight: 'bold',
    fontSize: '14px',
    textAlign: 'left',
    paddingLeft: '20px',
  },
};

export default AdminHeader;